var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "simple-row" }, [
      _c("div", { staticClass: "left" }, [
        _c(
          "div",
          {
            staticClass: "swb-btn swb-btn-small",
            on: {
              click: function($event) {
                _vm.setMaintProof()
              }
            }
          },
          [_c("span", [_vm._v("设置凭单模板")])]
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "column-layout" },
      [
        _c(
          "el-table",
          {
            staticStyle: { width: "100%" },
            attrs: {
              data: _vm.maintProofRelList,
              "max-height": "500",
              border: ""
            }
          },
          [
            _c("el-table-column", {
              attrs: {
                prop: "devcMaintProofTitle",
                label: "标题",
                align: "left",
                "show-overflow-tooltip": ""
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "devcMaintPeriod",
                label: "周期",
                align: "left",
                width: "150"
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "standard",
                label: "参考标准",
                align: "left",
                "show-overflow-tooltip": ""
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "appliedCatNames",
                label: "适用分类",
                align: "left",
                "show-overflow-tooltip": ""
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "操作", width: "80" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(rows) {
                    return [
                      _c(
                        "span",
                        {
                          staticClass: "swb-btn swb-btn-link",
                          on: {
                            click: function($event) {
                              _vm.deleteRel(rows.row.id)
                            }
                          }
                        },
                        [_vm._v("删除")]
                      )
                    ]
                  }
                }
              ])
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6249b7f8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6249b7f8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/retailer/ShopDeviceMaintProofRelList.vue
// module id = 3176
// module chunks = 0